<template>
  <div class="step mb-5">
    <div class="step-circle-number mb-4">
      <div
        class="step-circle-number-label"
        :style="`color: ${step.color}; border-color: ${step.border_color}`"
      >
        {{ step.number }}
      </div>
    </div>
    <div class="step-title text-center mb-md-3 mt-md-3">
      <h5>{{ step.title }}</h5>
    </div>
    <div class="step-description text-center">
      <p>{{ step.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeEasyStepItem',
  props: {
    step: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.step-circle-number {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-circle-number-label {
  font-size: 40px;
  line-height: 96px;
  width: 100px;
  height: 100px;
  border: 2px solid;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  text-align: center;
}

.step-description {
  font-weight: normal !important;
}
</style>
